import type { WidgetProps } from "@rjsf/utils";
import {
  CustomCheckbox,
  CustomDatePicker,
  CustomSelect,
  CustomText,
  CustomTextarea,
  DamageDegree,
} from "../../../../../../../Submissions/Widgets";
import { BaseWidgetPreview } from "./BaseWidgetPreview";

export function CheckboxWidgetPreview(props: WidgetProps) {
  return (
    <BaseWidgetPreview {...props}>
      <CustomCheckbox {...props} />
    </BaseWidgetPreview>
  );
}

export function DamageDegreeWidgetPreview(props: WidgetProps) {
  return (
    <BaseWidgetPreview {...props}>
      <DamageDegree {...props} />
    </BaseWidgetPreview>
  );
}

export function DateWidgetPreview(props: WidgetProps) {
  return (
    <BaseWidgetPreview {...props}>
      <CustomDatePicker {...props} />
    </BaseWidgetPreview>
  );
}

export function SelectWidgetPreview(props: WidgetProps) {
  return (
    <BaseWidgetPreview {...props}>
      <CustomSelect {...props} />
    </BaseWidgetPreview>
  );
}

export function TextareaWidgetPreview(props: WidgetProps) {
  return (
    <BaseWidgetPreview {...props}>
      <CustomTextarea {...props} />
    </BaseWidgetPreview>
  );
}

export function TextWidgetPreview(props: WidgetProps) {
  return (
    <BaseWidgetPreview {...props}>
      <CustomText {...props} />
    </BaseWidgetPreview>
  );
}
